import { ICellRendererParams } from "ag-grid-community";
import { ViewResultsIconAction } from "../Bid/BtnCellRenderer/BtnCellRenderer.styled";
import { ButtonActionContainer } from "../Bid/BtnCellRenderer/BtnCellRenderer.styled";
import { Button } from "@sede-enterprise/shell-ds-react-framework";
import { useAppDispatch } from "../../store";
import { ShowReturnsPanelAction } from "../../store/Returns/ActionCreator";
import { isReturnWindowOpen } from "../../helper/disabled-button";
import { ExchangeCode } from "../../services/Auction.service";

export interface ICapacityReturnsRenderer extends ICellRendererParams { 
  onSelectAuction?: (auctionId: string) => void;
}

export const CapacityReturnsRenderer: React.FC<ICapacityReturnsRenderer> = (
    props
) => {
  const dispatch = useAppDispatch();
  const {capacityReturnGateOpen, capacityReturnGateClose} = props.data;
  
  const isDisabled =
    !isReturnWindowOpen(capacityReturnGateOpen, capacityReturnGateClose)
    || props.data.exchangeCode !== ExchangeCode.Empire;

  const handleReturnClick = () => {
    // First, dispatch the action to show the Returns panel
    dispatch(ShowReturnsPanelAction(props.data));
    
    // Then start the row selection and scrolling process
    if (props.api) {
      // Clear any existing selections
      props.api.forEachNode(node => {
        if (node.id !== props.node.id && node.data) {
          node.setSelected(false);
        }
      });
      
      // Select this row
      props.node.setSelected(true);
      
      // Set the selected auction in the parent component
      if (props.context && props.context.setSelectedAuctionId) {
        props.context.setSelectedAuctionId(props.data.identification);
      }

      // Ensure we have a valid row index before attempting to scroll
      if (props.node.rowIndex !== null) {
        const rowIndex = props.node.rowIndex; // Store as a number type
        // Add the highlighting animation class to the row
        const rowNode = props.api.getDisplayedRowAtIndex(rowIndex);
        if (rowNode) {
          const rowElement = document.querySelector(`.ag-row[row-index="${rowIndex}"]`);
          if (rowElement) {
            rowElement.classList.add('scrolling-active');
          }
        }
        
        // Initial delay to ensure the Returns panel is visible
        setTimeout(() => {
          // Scroll to the selected row at the top of the grid view
          props.api.ensureIndexVisible(rowIndex, 'top');
          
          // Remove highlighting after animation completes
          setTimeout(() => {
            const rowElement = document.querySelector(`.ag-row[row-index="${rowIndex}"]`);
            if (rowElement) {
              rowElement.classList.remove('scrolling-active');
            }
          }, 2000); // Match the animation duration
        }, 1000); // 1 second delay before scrolling
      }
    }};
  
  return (
      <ButtonActionContainer>
        <Button
          className="shell-button-renderer"
          size="xsmall"
          disabled={isDisabled}
          onClick={handleReturnClick}>
            <ViewResultsIconAction />
            Return
          </Button>
      </ButtonActionContainer>)
  };